import React, { useState, useEffect, useRef } from "react";
import Container from "react-bootstrap/Container";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import Dropdown from "react-bootstrap/Dropdown";
import { apiPost, apiGet } from "../services/api";
import {
  CButton,
  COffcanvas,
  COffcanvasHeader,
  CCloseButton,
  COffcanvasBody,
} from "@coreui/react";

const Sidebar = ({ setAuth }) => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const roleName = user?.roleName?.toLowerCase();
  const isAdmin = roleName === "admin";
  const isRestrictedUser = roleName === "taskcoordinator" || roleName === "viewer";

  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  const [marqueeMessages, setMarqueeMessages] = useState([]);
  const notificationRef = useRef(null);
  const isFetchingRef = useRef(false);
  const [imageError, setImageError] = useState(false);
  const fetchMarqueeMessages = async () => {
    try {
      const res = await apiPost("/auth/GetTaskDetail", {}, true);
      let messages = [];

      const taskArray = Array.isArray(res)
        ? res
        : Array.isArray(res?.data)
          ? res.data
          : [];

      messages = taskArray.reverse().map(item => {
        const date = new Date(item.dateOfDecisionOrInitiation);
        const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
        return `Task ID:${item.taskID} - ${item.issueActionOrDecision}- Added on ${formattedDate}...`;
      });

      setMarqueeMessages(messages);
    } catch (error) {
      console.error("Marquee fetch error:", error);
    }
  };

  useEffect(() => {
    fetchMarqueeMessages();
  }, []);

  const fetchNotifications = async () => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;

    try {
      const userData = JSON.parse(sessionStorage.getItem("user"));
      const userId = userData?.userID;
      if (!userId) return;

      setLoadingNotifications(true);
      const response = await apiGet(`/Category/GetNotificationTaskTracking?userId=${userId}`, true);

      const dataArray = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response?.data?.data)
            ? response.data.data
            : [];

      const formatted = dataArray.map(item => ({
        id: item.notificationId,
        message: item.issueActionOrDecision,
      }));

      setNotifications(formatted.reverse());
    } catch (error) {
      console.error("Notification fetch error:", error);
      setNotifications([]);
    } finally {
      setLoadingNotifications(false);
      isFetchingRef.current = false;
    }
  };
const reportPaths = [
  "/dashboard/Reports",
  "/dashboard/UserLoginHistory",
  "/dashboard/UserTaskUpdate",
  "/dashboard/UserFrequency",
  "/dashboard/voiceSearch"
];

const settingPaths = [
  "/dashboard/setting",
  "/dashboard/Changemasterheader",

];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications]);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await apiPost("/auth/logout", {}, true);
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      if (setAuth) setAuth(false);
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
      alert(error?.response?.data?.message || error?.message || "Logout failed. Try again.");
    }
  };


  const handleClearNotifications = async () => {
    try {
      const userData = JSON.parse(sessionStorage.getItem("user"));
      const userId = userData?.userID;

      const notificationIdsArray = notifications.map(n => n.id).filter(Boolean);
      if (!notificationIdsArray.length || !userId) return;

      const payload = {
        notificationIds: notificationIdsArray.join(","),
        seenByUserId: userId,
      };

      await apiPost("/auth/SeenNotificationAsSeen", payload, true);
      setNotifications([]);
    } catch (error) {
      console.error("Notification Clear Error:", error);
    }
  };

  return (
    <>

      <Navbar expand="lg" className="bg-body-tertiary">
        <Container>
          <CButton className="custommenubtn" onClick={() => setVisible(true)}>
            <i className="bi bi-list"></i>
          </CButton>
          <Dropdown>
            <div className="userprofilediv">
              <Dropdown.Toggle className="userprofile" id="dropdown-basic">
                <div className="main-userimagediv">

              
                <div className="userimg">
                  {user?.userImage && !imageError ? (
                    <img
                      src={`${process.env.REACT_APP_API_BASE_URL}/${user.userImage}`}
                      alt="userimg"
                      onError={() => setImageError(true)}
                    />
                  ) : (
                    <i className="bi bi-person-circle fs-2 text-secondary"></i> 
                  )}
                </div>
                   <div className="usernamesub-div">
               <div className="username-div">{user?.userName}</div> 
                <div className="userrole-div"> ( {user?.roleName} )</div> 
                </div>
                  </div>
              </Dropdown.Toggle>
              
            </div>


            <Dropdown.Menu className="customdropdown-list">
              <Dropdown.Item href="/">Setting</Dropdown.Item>
              <Dropdown.Item href="/" onClick={handleLogout}>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Container>
      </Navbar>


<COffcanvas placement="start" visible={visible} onHide={() => setVisible(false)} id="sidebar">
<COffcanvasHeader>


  <CCloseButton className="text-reset closecustombtn" onClick={() => setVisible(false)}>
    <i className="bi bi-x-lg"></i>
  </CCloseButton>
</COffcanvasHeader>

        <COffcanvasBody>
          <ul id="sidebarMenu" className="sidebarcustom">
            <li className={location.pathname === "/dashboard" ? "active" : ""} onClick={() => navigate("/dashboard")}>
              <i className="bi bi-house"></i> Dashboard
            </li>

            {(isAdmin || !isRestrictedUser) && (
              <>
                <li className={location.pathname === "/dashboard/department" ? "active" : ""} onClick={() => navigate("/dashboard/department")}>
                  <i className="bi bi-app-indicator"></i> Department
                </li>
                <li className={location.pathname === "/dashboard/category" ? "active" : ""} onClick={() => navigate("/dashboard/category")}>
                  <i className="bi bi-bookmarks"></i> Category
                </li>
                <li className={location.pathname === "/dashboard/UserRole" ? "active" : ""} onClick={() => navigate("/dashboard/UserRole")}>
                  <i className="bi bi-layout-wtf"></i> User Role
                </li>
                <li className={location.pathname === "/dashboard/userCretaion" ? "active" : ""} onClick={() => navigate("/dashboard/userCretaion")}>
                  <i className="bi bi-person-plus"></i> User Creation
                </li>
                <li className={location.pathname === "/dashboard/Group" ? "active" : ""} onClick={() => navigate("/dashboard/Group")}>
                  <i className="bi bi-people"></i> Group
                </li>
                <li className={location.pathname === "/dashboard/archive" ? "active" : ""} onClick={() => navigate("/dashboard/archive")}>
                  <i className="bi bi-archive"></i> Archive
                </li>
                <li className={location.pathname === "/dashboard/trash" ? "active" : ""} onClick={() => navigate("/dashboard/trash")}>
                  <i className="bi bi-trash"></i> Trash
                </li>
              
                <li
  className={settingPaths.includes(location.pathname) ? "active" : ""}
  onClick={() => navigate("/dashboard/setting")}
>
    <i className="bi bi-gear"></i> Setting
</li>
              </>
            )}

   
<li
  className={reportPaths.includes(location.pathname) ? "active" : ""}
  onClick={() => navigate("/dashboard/Reports")}
>
  <i className="bi bi-journal-arrow-up"></i> Reports
</li>

            <li className={location.pathname === "/dashboard/notification" ? "active" : ""} onClick={() => navigate("/dashboard/notification")}>
              <i className="bi bi-bell"></i> Notification
            </li>
            <li className={location.pathname === "/dashboard/timeline" ? "active" : ""} onClick={() => navigate("/dashboard/timeline")}>
              <i className="bi bi-key"></i> Timeline
            </li>
            <li className={location.pathname === "/dashboard/selectministry" ? "active" : ""} onClick={() => navigate("/dashboard/selectministry")}>
              <i className="bi bi-key"></i> Select Ministry
            </li>
            <li className={location.pathname === "/dashboard/changepassword" ? "active" : ""} onClick={() => navigate("/dashboard/changepassword")}>
              <i className="bi bi-key"></i> Change Password
            </li>
          </ul>
        </COffcanvasBody>
      </COffcanvas>


      <section className="headerimage">
        <img src={process.env.PUBLIC_URL + "/dashboard-header.jpg"} alt="dashboard header" className="img-fluid" />
      </section>


      <div className="container mt-2">
        <div className="headingsearchbar">
          <div className="welcome-dashboard-heading col-md-7">
            <h2 className="mt-3">ePARINAM Ministry of Tourism</h2>
          </div>

          <div className="col-md-5 d-flex justify-content-end align-items-center gap-3">
            <div className="input-group searchcustom" style={{ maxWidth: "300px" }}>
              <input className="form-control py-2" type="text" placeholder="Search.." />
              <div className="input-group-append">
                <button className="btn btn-btn-primary searchbtn" type="button">
                  <i className="bi bi-search"></i>
                </button>
              </div>
            </div>

            <div className="position-relative" ref={notificationRef}>
              <div
                className="notification-bell rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#f5f5f5",
                  border: "1px solid #ccc",
                  cursor: "pointer",
                  position: "relative",
                }}
                onClick={() => {
                  setShowNotifications(prev => {
                    if (!prev) fetchNotifications();
                    return !prev;
                  });
                }}
              >
                <i className="bi bi-bell fs-5 text-dark"></i>
                {notifications.length > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: "9px", width:"26px", height:"26px", top:"20px", lineHeight: "21px" }}>
                    {notifications.length}
                  </span>
                )}
              </div>

              {showNotifications && (
                <div
                  className="notification-dropdown shadow"
                  style={{
                    position: "absolute",
                    top: "50px",
                    right: "0",
                    width: "350px",
                    zIndex: 1000,
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    overflow: "hidden",
                  }}
                >
                  <div style={{
                    backgroundColor: "#176B87",
                    color: "#fff",
                    padding: "10px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}>
                    <i className="bi bi-bell-fill"></i> Notifications ({notifications.length})
                  </div>

                  <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                    {loadingNotifications ? (
                      <div style={{ padding: "15px", textAlign: "center" }}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : notifications.length > 0 ? (
                      notifications.map((notification) => (
                        <div
                          key={notification.id}
                          onClick={() => navigate(`/dashboard/notification/${notification.id}`)}
                          style={{
                            padding: "12px 15px",
                            borderBottom: "1px solid #eee",
                            fontSize: "14px",
                            cursor: "pointer",
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          {notification.message}
                        </div>
                      ))
                    ) : (
                      <div style={{ padding: "15px", textAlign: "center", color: "#666" }}>
                        <i className="bi bi-bell-slash" style={{ fontSize: "20px", marginBottom: "5px" }}></i>
                        <div>No new notifications</div>
                      </div>
                    )}
                  </div>

                  <div className="d-flex justify-content-between" style={{ padding: "10px", backgroundColor: "#f1f1f1", borderTop: "1px solid #ddd" }}>
                    <button className="btn button-clearall" onClick={handleClearNotifications} disabled={notifications.length === 0 || loadingNotifications}>
                       Clear All
                    </button>
                    <button className="btn button-close" onClick={() => setShowNotifications(false)}>
                   Close
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="tagline mt-4">
        <p id="TickerMarquee">
          <marquee className="atitle" scrollamount="4" direction="left" loop="40" width="99%" id="taskticker1">
            {marqueeMessages.length > 0
              ? marqueeMessages.join(" || ")
              : "No tasks available right now..."}
          </marquee>
        </p>
      </div>
    </>
  );
};

export default Sidebar;
